module.exports = __webpack_public_path__ + "static/media/app.071786aa.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/app.gif
// module id = 147
// module chunks = 0